/**
 * Unify same refunds in one single object.
 * This is usefull when having refunds for sales with more than one installment.
 */
export const selectRefundsSummary = (state) => {
  const refundsSummary = state.transactions.dataRefunds.reduce((history, refund) => {
    if (!history[refund.authorization_id]) {
      history[refund.authorization_id] = {
        authorization_id: refund.authorization_id,
        gross_value: refund.gross_value,
        event_date: refund.event_date,
      };
    } else {
      history[refund.authorization_id].gross_value += refund.gross_value;
    }
    return history;
  }, {});

  return Object.values(refundsSummary);
};
